export default (props, vars) =>
  `${vars?.['useapplicationoffer2']?.['applicationOffer'].terms.type} Overview`;
